// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"532":"382ae09dc75b9c81","888":"4ebd38b26f6bfe76"}[chunkId] + ".css";
};